import { defineComponent, createElementBlock, openBlock, normalizeStyle, normalizeClass, createVNode, createElementVNode, withCtx, renderSlot } from 'vue';
import _sfc_main$1 from './basler-components.es83.js';
/* empty css                       */
import _sfc_main$2 from './basler-components.es110.js';
/* empty css                        */

const _hoisted_1 = { class: "alert-box__text" };
const _hoisted_2 = ["innerHTML"];
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "AlertBox",
  props: {
    icon: { default: "info" },
    text: {},
    style: { default: "info" },
    maxWidth: { default: "none" }
  },
  emits: ["click", "mouseover", "mouseleave"],
  setup(__props, { emit: __emit }) {
    const emit = __emit;
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["alert-box", `alert-box--is-${_ctx.style}-style`]),
        style: normalizeStyle(_ctx.maxWidth !== "none" ? `max-width: ${_ctx.maxWidth}px` : void 0),
        onClick: _cache[0] || (_cache[0] = ($event) => emit("click")),
        onMouseover: _cache[1] || (_cache[1] = ($event) => emit("mouseover")),
        onMouseleave: _cache[2] || (_cache[2] = ($event) => emit("mouseleave"))
      }, [
        createVNode(_sfc_main$1, {
          tag: "span",
          icon: _ctx.icon,
          class: "alert-box__icon"
        }, null, 8, ["icon"]),
        createElementVNode("div", _hoisted_1, [
          createVNode(_sfc_main$2, null, {
            default: withCtx(() => [
              renderSlot(_ctx.$slots, "default", {}, () => [
                createElementVNode("div", { innerHTML: _ctx.text }, null, 8, _hoisted_2)
              ])
            ]),
            _: 3
          })
        ])
      ], 38);
    };
  }
});

export { _sfc_main as default };
